export const COUNTRY_TIMEZONE = {
  us: 'America/New_York',
  ca: 'America/Toronto',
  gb: 'Europe/London',
  de: 'Europe/Berlin',
  dk: 'Europe/Copenhagen',
  ae: 'Asia/Dubai',
  sa: 'Asia/Riyadh',
  ch: 'Europe/Zurich',
};
